import camelCase from 'lodash.camelcase';
import { Dictionary } from 'vuex';

export type Camelized = Dictionary<any>;

const camelize = (source: any): Camelized => {
    if (typeof source !== 'object') {
        return {};
    }

    return Object.keys(source).reduce((res, key) => {
        res[camelCase(key)] = source[key];
        return res;
    }, {} as Camelized);
};

export default camelize;



// WEBPACK FOOTER //
// ./src/tools/camelize.ts